import React, { useState } from "react";

import "./dashboard.css";

import "react-responsive-modal/styles.css";
import Breadcrumbs from "../layout/breadcrumb";
import ProjectDetail from "../../assets/Icons/projectDetails.png";
import Resources from "../../assets/Icons/Resourecs.png";
import Quality from "../../assets/Icons/Quality.png";
import DPR from "../../assets/Icons/dpr.png";
import Safety from "../../assets/Icons/Safety.png";
import RiskRegister from "../../assets/Icons/RiskRegister.png";
import IssueRegister from "../../assets/Icons/IssueRegister.png";
import Learning from "../../assets/Icons/Learning.png";

import ProjectArchival from "../../assets/Icons/projectArchival.png";
import ProjectHandover from "../../assets/Icons/projectHandover.png";
import PostHandover from "../../assets/Icons/postHandOver.png";
import DocumentRepository from "../../assets/Icons/documentRepository.png";
import Reports from "../../assets/Icons/Report.png";
import { useLocation } from "react-router-dom";
import Tiles from "../../compnenets/commons/tiles";
import { useNavigate } from "react-router-dom";

function MyProjects() {
  const location = useLocation();
  const data = location.state || {};
  const navigate = useNavigate();

  return (
    <div className="pb-5">
      <Breadcrumbs
        title="Dashboard Site Engineer"
        menu="My Projects"
        link="Dashboard Site Engineer"
      />
      <div className="row">
        <div
          className="col-3"
          onClick={() => {
            navigate("/project-details", { state: data });
          }}
        >
          <Tiles icon={ProjectDetail} title="Project Details" />
        </div>
        <div
          className="col-3"
          onClick={() => {
            navigate("/dpr-list", { state: data });
          }}
        >
          <Tiles icon={DPR} title="DPR" />
        </div>
        <div
          className="col-3"
          onClick={() => {
            navigate("/resourece", { state: data });
          }}
        >
          <Tiles icon={Resources} title="Resources" />
        </div>
        <div
          className="col-3"
          onClick={() => {
            navigate("/quality", { state: data });
          }}
        >
          <Tiles icon={Quality} title="Quality" />
        </div>
      </div>

      <div className="row mt-3">
        <div
          className="col-3"
          onClick={() => {
            navigate("/safety", { state: data });
          }}
        >
          <Tiles icon={Safety} title="Safety" />
        </div>
        <div
          className="col-3"
          onClick={() => {
            navigate("/risk-register", { state: data });
          }}
        >
          <Tiles icon={RiskRegister} title="Risk Register" />
        </div>
        <div
          className="col-3"
          onClick={() => {
            navigate("/issue-register", { state: data });
          }}
        >
          <Tiles icon={IssueRegister} title="Issue Register" />
        </div>
        <div
          className="col-3"
          onClick={() => {
            navigate("/learning", { state: data });
          }}
        >
          <Tiles icon={Learning} title="Learning" />
        </div>
      </div>

      <div className="row mt-3">
        <div
          className="col-3"
          onClick={() => {
            navigate("/project-archival", { state: data });
          }}
        >
          <Tiles icon={ProjectArchival} title="Project Archival" />
        </div>
        <div
          className="col-3"
          onClick={() => {
            navigate("/project-handover", { state: data });
          }}
        >
          <Tiles icon={ProjectHandover} title="Project Handover" />
        </div>
        <div
          className="col-3"
          onClick={() => {
            navigate("/post-handover-complaint", { state: data });
          }}
        >
          <Tiles icon={PostHandover} title="Post Handover Complaint form" />
        </div>
        <div
          className="col-3"
          onClick={() => {
            navigate("/documnet-repository", { state: data });
          }}
        >
          <Tiles icon={DocumentRepository} title="Document Repository" />
        </div>
      </div>

      <div className="row mt-3">
        <div
          className="col-3"
          onClick={() => {
            navigate("/report", { state: data });
          }}
        >
          <Tiles icon={Reports} title="Reports" />
        </div>
      </div>
    </div>
  );
}

export default MyProjects;
